import rulesList from "./config";
import Vue, { ComponentOptions } from "vue";
import { CombinedVueInstance, ExtendedVue } from "vue/types/vue";
import { checkRuleCB } from "@/lib/types";

export function checkByUserRole(ruleName: string, userRole: string): boolean {
  // TODO: Add check for empty args.
  if (!rulesList[ruleName]) return false;
  return rulesList[ruleName].roles.indexOf(userRole) > -1;
}

export function checkByAuthorities(currentAuthorities: string[], ruleName: string, ruleKey: string): boolean {
  // TODO: Add check for empty args.
  if (!rulesList[ruleName] || !rulesList[ruleName][ruleKey]) return false;
  const requiredAuthorities = rulesList[ruleName][ruleKey];
  for (const auth of requiredAuthorities) {
    if (currentAuthorities.indexOf(auth) === -1) {
      return false;
    }
  }
  return true;
}

function isVueConstructor(
  component: ComponentOptions<Vue> | ExtendedVue<Vue, unknown, unknown, unknown, unknown>
): component is ExtendedVue<Vue, unknown, unknown, unknown, unknown> {
  return typeof (component as ExtendedVue<Vue, unknown, unknown, unknown, unknown>).extend === "function";
}

export function getComponentName(
  component: ComponentOptions<Vue> | ExtendedVue<Vue, unknown, unknown, unknown, unknown>
): string {
  let options: ComponentOptions<Vue>;
  if (isVueConstructor(component)) {
    options = (component as any).sealedOptions;
  } else {
    options = component;
  }
  return options.name || "";
}

export function computedCheckAuthorities(
  this: CombinedVueInstance<Vue, { [key: string]: any }, unknown, unknown, unknown>,
  ruleName: string | checkRuleCB,
  authRuleKey: string | checkRuleCB
) {
  if (typeof authRuleKey === "function") authRuleKey = authRuleKey(this);
  if (typeof ruleName === "function") ruleName = ruleName(this);
  return checkByAuthorities(this.$store.state.loggedInUser.authorities, ruleName, authRuleKey);
}

export function computedCheckUserRole(
  this: CombinedVueInstance<Vue, { [key: string]: any }, unknown, unknown, unknown>,
  ruleName: string | checkRuleCB,
  currentUserRole: string | checkRuleCB
) {
  if (typeof currentUserRole === "function") currentUserRole = currentUserRole(this);
  if (typeof ruleName === "function") ruleName = ruleName(this);
  return checkByUserRole(ruleName, currentUserRole);
}
